import React, { Children } from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: '🏠',
  title: 'Autonomía Respetada',
  description: 'Nuestro enfoque es para adultos autoválidos. Fomentamos que sigan decidiendo sobre su vida, en un entorno seguro y adaptado.'
}, {
  icon: '👩‍⚕️',
  title: 'Salud Integral',
  description: 'Desde nutrición personalizada hasta bioingeniería y kinesiología. Todo el equipo médico está aquí para prevenir y fortalecer.'
}, {
  icon: '🌿',
  title: 'Entorno Natural',
  description: 'Ubicados en General Ramírez, Entre Ríos, ofrecemos aire puro y espacios verdes para que cada día se sienta como un descanso activo.'
}, {
  icon: '🤝',
  title: 'Vínculo Familiar',
  description: 'No aislamos al abuelo. Creamos puentes. Las familias son parte fundamental de la vida diaria en nuestra institución.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Benefits() {
  return <section id="porque" className="py-20 px-5 md:px-[5%] bg-fondo-crema" data-id="element-12">
      <div className="max-w-7xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-[800px] mx-auto mb-[60px]" data-id="element-14">
          <h2 className="text-verde-oscuro text-3xl md:text-[2.8rem] font-serif mb-5" data-id="element-15">
            ¿Por qué confiar en Vínculos de Vida?
          </h2>
          <p className="text-lg font-sans" data-id="element-16">
            Entendemos que tomar esta decisión no es fácil. Por eso, hemos
            diseñado un modelo de residencia donde la dignidad del adulto mayor
            es el eje central de todo lo que hacemos.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-[30px]" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-17">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-10 rounded-[10px] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] shadow-[0_5px_15px_rgba(0,0,0,0.02)]" data-id="element-18">
              <span className="text-[2rem] block mb-5" data-id="element-19">{benefit.icon}</span>
              <h4 className="text-verde-oscuro text-[1.4rem] font-serif mb-4" data-id="element-20">
                {benefit.title}
              </h4>
              <p className="text-texto font-sans leading-relaxed" data-id="element-21">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}